let moment = require("jalali-moment");

export default {
  data() {
    return {
      formData: new FormData(),
      errorImage: require("@/assets/images/notFound.png"),
    };
  },
  methods: {
    validatorUuid: (uuid) => {
      /* eslint-disable no-useless-escape */
      const cRegExp =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      /* eslint-enable no-useless-escape */
      const validUuid = cRegExp.test(uuid);
      return validUuid;
    },
    blurPicker(e) {
      e.target && e.target.blur();
    },
    hasOwnNestedProperty(object, propertyPath) {
      let properties = propertyPath.split(".");
      let obj = object;
      let result = true;
      properties.map((item) => {
        if (!obj || !obj.hasOwnProperty(item)) {
          result = false;
        } else {
          obj = obj[item];
        }
      });
      return result;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "0";
      }
    },
    decodePersianName(x) {
      let decodedPersianString = x
        .replace(/[\u200B-\u200C\uFEFF]/g, " ")
        .replace(/  +/g, " ")
        .replace("/", "-")
        .split(" ")
        .join("-");
      return decodedPersianString;
    },
    toLocal(val) {
      let toCurrentLocal = moment.utc(val).local().format();
      return val ? moment(toCurrentLocal).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    setFormData(element, index, append) {
      if (Array.isArray(element)) {
        element.forEach((element, index) => {
          this.setFormData(element, index, append + `[${index}]`);
        });
      } else if (
        typeof element == "object" &&
        !!element &&
        element instanceof File === false
      ) {
        for (const [key, value] of Object.entries(element)) {
          this.setFormData(value, key, append + `[${key}]`);
        }
      } else if (!!element || element === 0) {
        this.formData.append(append, element);
      }
    },
    toUtc(val) {
      let utc = val ? moment(val).utc().format("YYYY-MM-DD HH:mm:ss") : "";
      return utc;
    },
    calRemaining(competition) {
      const { registration_begin, registration_end, started_at, ended_at } =
        competition;
      let timeObj = {};
      let nowTimeStamp = moment().unix();
      let currentDate = moment();
      let startRegisterTimeStamp = moment(registration_begin).format("X");
      let endRegisterTimeStamp = moment(registration_end).format("X");
      let startCompetitionTimeStamp = moment(started_at).format("X");
      let endCompetitionTimeStamp = moment(ended_at).format("X");
      /**
       // return nowTimeStamp < startRegisterTimeStamp
      //   ? "yellow"
      //   : nowTimeStamp > startRegisterTimeStamp &&
      //     nowTimeStamp < endRegisterTimeStamp
      //   ?  'warning'
      //   : startCompetitionTimeStamp < nowTimeStamp &&
      //     nowTimeStamp < endCompetitionTimeStamp
      //   ? {
      //     status:"success",
      //     time : moment(registration_begin).format("X")

      //   }
      //   : "danger";

      */
      if (nowTimeStamp < Number(startRegisterTimeStamp)) {
        return {
          status: "yellow",
          message: "Register starts at",
          time: moment(registration_begin).format("YY-MM-DD HH:mm"),
        };
      }

      if (
        nowTimeStamp >= Number(startRegisterTimeStamp) &&
        nowTimeStamp <= Number(endRegisterTimeStamp)
      ) {
        return {
          status: "warning",
          message: "Register in progress to",
          time: moment(registration_end).format("YY-MM-DD HH:mm"),
        };
      }

      if (
        Number(startCompetitionTimeStamp) <= nowTimeStamp &&
        nowTimeStamp <= Number(endCompetitionTimeStamp)
      ) {
        return {
          status: "success",
          message: "Register is ended and competition started at",
          time: moment(started_at).format("YY-MM-DD HH:mm"),
        };
      }

      return {
        status: "danger",
        message: "The competition is over!",
        time: moment(ended_at).format("YY-MM-DD HH:mm"),
      };

      // if (nowTimeStamp > endCompetitionTimeStamp) {
      //   timeObj.competitionEnded = true;
      // }
      // if (
      //   nowTimeStamp > startCompetitionTimeStamp &&
      //   nowTimeStamp < endCompetitionTimeStamp
      // ) {
      //   timeObj.competitionIsOn = true;
      // }
      // if (startRegisterTimeStamp > nowTimeStamp) {
      //   timeObj.title = "Registration begin";
      //   timeObj.remain = this.calRemain(registration_begin, currentDate);
      // } else if (startCompetitionTimeStamp > nowTimeStamp) {
      //   timeObj.title = "Registration end and Competition begin";
      //   timeObj.remain = this.calRemain(started_at, currentDate);

      //   timeObj.total = moment(registration_end).diff(
      //     registration_begin,
      //     "seconds"
      //   );
      // timeObj.rate = currentDate.diff(registration_begin, "seconds");
      // }
      // return timeObj;
    },
    calRemain(date1, date2) {
      return moment(date1).diff(date2, "days")
        ? moment(date1).diff(date2, "days") + " days "
        : moment(date1).diff(date2, "hours")
        ? moment(date1).diff(date2, "hours") + " hours "
        : moment(date1).diff(date2, "minutes")
        ? moment(date1).diff(date2, "minutes") + " minutes "
        : moment(date1).diff(date2, "seconds")
        ? moment(date1).diff(date2, "seconds") + " seconds "
        : "";
    },
    fromNow(date) {
      return moment(date).fromNow(true);
    },
    getDifference(date2) {
      let currentDate = moment();
      let myDate = moment.utc(date2 * 1000).local();
      let res = "";
      let diffTime = myDate.diff(currentDate, "seconds");
      let day = parseInt(diffTime / (24 * 3600));
      day > 0 ? (res += day + " day ") : "";
      diffTime = diffTime % (24 * 3600);
      let hour = parseInt(diffTime / 3600);
      hour > 0 ? (res += hour + " hour ") : "";
      diffTime %= 3600;
      let minutes = parseInt(diffTime / 60);
      minutes > 0 ? (res += minutes + " minute ") : "";
      diffTime %= 60;
      let seconds = parseInt(diffTime);
      seconds > 0 ? (res += seconds + " second ") : "";
      return { res, time: { day, hour, minutes, seconds } };
    },
    p2e: (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)),
    setAltImg(event) {
      event.target.src = this.errorImage;
      event.target.alt = "";
    },
  },
};
